import redirect from './redirect.lib';

export default {
  // return url이 없으면 현재 페이지를 redirect url로 사용
  moveToLoginPage(returnUrl, queryString) {
    const url = this.getLoginPageUrl(returnUrl);

    if (queryString === undefined || queryString === null) {
      redirect.get(url);
    } else {
      redirect.post(url, { return_query_string: queryString });
    }
  },

  getLoginPageUrl(returnUrl) {
    let loginUrl = '/account/login?return_url=';

    if (returnUrl === undefined) {
      loginUrl += encodeURIComponent(window.location.href);
    } else {
      loginUrl += encodeURIComponent(returnUrl);
    }

    return loginUrl;
  },
};



// WEBPACK FOOTER //
// ./common/account.lib.m.js